import { observer } from 'mobx-react-lite';
import {
  Button,
  Header,
  Segment,
  Form,
  Select,
  Input,
} from 'semantic-ui-react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import MyTextInput from '../../app/common/form/MyTextInput';
import { store, useStore } from '../../app/stores/store';
import { v4 as uuid } from 'uuid';
import { initialVaultData, Vault } from '../../app/models/vault';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { SyntheticEvent, useEffect, useState } from 'react';
import '../../app/common/MediaQuery/responsive-forms.css';
import { countryOptions } from '../../app/common/options/countrystateOptions/countryOptions';
import {
  errorEmptyText,
  vaulterrorMessageText,
} from '../../app/common/form/errorMessageText';

interface Props {
  viewPort: boolean;
}
function VaultMasterForm({ viewPort = true }: Props) {
  const {
    vaultStore,
    modalStore,
    dashboardStore,
    commonStore,
    userStore: { user },
  } = useStore();
  const {
    createVault,
    selectedVault,
    updateVault,
    vaultitemsByDate,
    vaultRegistry,
    loadVaults,
  } = vaultStore;
  const [errorType, setErrorType] = useState<string>('');
  const [vaultData, setVaultData] = useState<Vault>(initialVaultData);
  const phoneRegExp = /^(\+|\d)[0-9]{9,16}$/;

  useEffect(() => {
    // updating
    if (
      selectedVault?.id !== undefined &&
      dashboardStore.dashboard.formikClearFormBool === true
    ) {
      const newArr = {
        ...selectedVault,
      };
      setVaultData(newArr);
    }
    // eslint-disable-next-line
  }, [selectedVault]);

  const handleSubmit = (values: Vault) => {
    if (values.id === '') {
      // vault id is null for creating vault
      const newvaultData = {
        ...values,
        id: uuid(),
      };
      createVault(newvaultData);
      dashboardStore.dashboard.formikClearFormBool = false;
      store.vaultStore.selectedVault = undefined;
    } else {
      const updatedVaultData = {
        ...values,
      };
      updateVault(updatedVaultData);
      dashboardStore.dashboard.formikClearFormBool = false;
      store.vaultStore.selectedVault = undefined;
    }
    modalStore.closeModal();
    setVaultData(initialVaultData);
  };
  ////////////////////handle Cancel
  const handleCancel = () => {
    setVaultData(initialVaultData);
    modalStore.closeModal();
    dashboardStore.dashboard.formikClearFormBool = false;
    store.vaultStore.selectedVault = undefined;
  };
  useEffect(() => {
    if (vaultRegistry.size <= 1) loadVaults();
  }, [vaultRegistry.size, loadVaults]);
  ////////////////////handle Change
  const handleChange = (e: any) => {
    const newArr = {
      ...vaultData,
      [e.target.name]: e.target.value,
    };
    setVaultData(newArr);
    const NameCheck = vaultitemsByDate.some(function (el: any) {
      return (
        el.vaultName.trim().toLowerCase() ===
        e.target.value.trim().toLowerCase()
      );
    });
    setErrorType(NameCheck ? 'SameName' : '');
  };
  const changeLocation = (e: SyntheticEvent, data: any) => {
    setVaultData({ ...vaultData, [data.name]: data.value });
  };

  return (
    <div id={viewPort ? 'parent-grid-vault' : ''}>
      <Segment clearing className="vault-form-segment" responsive={true}>
        <Header
          icon="edit"
          size="huge"
          dividing
          as="h1"
          content={
            user?.customerName === 'LVP CMS - AM'
              ? 'ROOM MASTER'
              : (userLanguage[0].VAULTMASTERRegisterVault?.VMRVL01 as any)?.[
                  `${commonStore.language.key}`
                ]
          }
          sub
          color="grey"
        />
        <Formik
          initialValues={vaultData}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            handleSubmit(values);
            resetForm();
          }}
          validationSchema={Yup.object({
            vaultName: Yup.string()
              .min(2)
              .max(70)
              .required('Please enter a name'),
            vaultCode: commonStore.hfcCustomerChanges ? Yup.string().notRequired() : Yup.string()
              .min(2)
              .max(10)
              .required('Please enter a vault code'),
            vaultContactPersonName:commonStore.hfcCustomerChanges ? Yup.string().notRequired() : Yup.string()
              .required('Please enter contact person name')
              .matches(
                /^[aA-zZ\s]+$/,
                'Only alphabets are allowed for this field ',
              ),
            vaultCountryLocation: commonStore.hfcCustomerChanges ? Yup.string().notRequired() : Yup.string().required(
              'Please enter valid location',
            ),
            vaultContactPersonPhone:commonStore.hfcCustomerChanges ? Yup.string().notRequired() : Yup.string()
              .min(9)
              .max(16)
              .matches(phoneRegExp, 'Please enter a valid phone number')
              .required('Please enter your phone number'),
            //  phoneNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid')
          })}
        >
          {({ handleSubmit, isSubmitting }) => (
            <>
              <Form className="ui form error" autoComplete="off">
                <Form.Group widths="equal">
                  <Form.Field
                    label={
                      user?.customerName === 'LVP CMS - AM'
                        ? 'Room Name'
                        : (
                            userLanguage[0].VAULTMASTERRegisterVault
                              ?.VMRVL02 as any
                          )?.[`${commonStore.language.key}`]
                    }
                    id="form-input-control-error-email"
                    name="vaultName"
                    error={
                      errorType === 'SameName'
                        ? vaulterrorMessageText
                        : errorType === 'EmptyName'
                          ? errorEmptyText
                          : null
                    }
                    control={Input}
                    value={vaultData.vaultName}
                    placeholder={
                      user?.customerName === 'LVP CMS - AM'
                        ? 'Room Name'
                        : (
                            userLanguage[0].VAULTMASTERRegisterVault
                              ?.VMRVL02 as any
                          )?.[`${commonStore.language.key}`]
                    }
                    //"Vault Name"
                    onChange={(e: any) => handleChange(e)}
                  />
                  {/* <MyTextInput value={vaultData.vaultName}  onChange={(e:any)=>handleChange(e)} name='vaultName' placeholder='Vault Name' label={userLanguage[0].VAULTMASTERRegisterVault?.VMRVL02 as any)?.[`${commonStore.language.key}`]}/> */}
                  <MyTextInput
                    value={vaultData.vaultCode}
                    name="vaultCode"
                    onChange={(e: any) => handleChange(e)}
                    placeholder={
                      user?.customerName === 'LVP CMS - AM'
                        ? 'Room Code'
                        : (
                            userLanguage[0].VAULTMASTERRegisterVault
                              ?.VMRVL03 as any
                          )?.[`${commonStore.language.key}`]
                    }
                    //'Vault Code'
                    label={
                      user?.customerName === 'LVP CMS - AM'
                        ? 'Room Code'
                        : (
                            userLanguage[0].VAULTMASTERRegisterVault
                              ?.VMRVL03 as any
                          )?.[`${commonStore.language.key}`]
                    }
                  />
                  {/* <MyTextInput value={vaultData.vaultCountryLocation}   name='vaultCountryLocation' placeholder='Country'  onChange={(e:any)=>handleChange(e)} label={userLanguage[0].VAULTMASTERRegisterVault?.VMRVL04 as any)?.[`${commonStore.language.key}`]}  /> */}
                  <Form.Field
                    control={Select}
                    value={vaultData.vaultCountryLocation}
                    options={countryOptions}
                    label={
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL04 as any
                      )?.[`${commonStore.language.key}`]
                    }
                    search
                    name="vaultCountryLocation"
                    placeholder={
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL04 as any
                      )?.[`${commonStore.language.key}`]
                    } //"Country"
                    clearable={true}
                    onChange={changeLocation}
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  <MyTextInput
                    value={vaultData.vaultGPSLocation}
                    onChange={(e: any) => handleChange(e)}
                    name="vaultGPSLocation"
                    placeholder={
                    user?.customerName === 'PCPLCRM' && user?.roleName === 'IT Team' ? 'Location' : (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL05 as any
                      )?.[`${commonStore.language.key}`]
                    } //'GPS Location'
                    label={
                      user?.customerName === 'PCPLCRM' && user?.roleName === 'IT Team' ? 'Location' : (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL05 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  />
                  <MyTextInput
                    value={vaultData.vaultContactPersonName}
                    onChange={(e: any) => handleChange(e)}
                    name="vaultContactPersonName"
                    placeholder={
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL06 as any
                      )?.[`${commonStore.language.key}`]
                    } //'Contact Person Name'
                    label={
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL06 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  />
                  <MyTextInput
                    value={vaultData.vaultContactPersonPhone}
                    onChange={(e: any) => handleChange(e)}
                    name="vaultContactPersonPhone"
                    placeholder={
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL07 as any
                      )?.[`${commonStore.language.key}`]
                    } //'Contact Person Phone'
                    label={
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVL07 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  />
                </Form.Group>
                <Button.Group floated="right" style={{ marginTop: '40px' }}>
                  <Button onClick={handleCancel}>
                    {
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVB01 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </Button>
                  <Button.Or
                    text={
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVB02 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  />
                  <Button
                    onClick={() => handleSubmit()}
                    disabled={
                      !commonStore.hfcCustomerChanges ? 
                      !vaultData.vaultName ||
                      errorType === 'SameName' ||
                      errorType === 'EmptyName' ||
                      !vaultData.vaultCode ||
                      !vaultData.vaultContactPersonPhone ||
                      !vaultData.vaultContactPersonName : !vaultData.vaultName
                    }
                    loading={isSubmitting}
                    type="submit"
                    content="Submit"
                    positive
                  >
                    {' '}
                    {
                      (
                        userLanguage[0].VAULTMASTERRegisterVault?.VMRVB03 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </Button>
                </Button.Group>
              </Form>
            </>
          )}
        </Formik>
      </Segment>
    </div>
  );
}
export default observer(VaultMasterForm);
